<template lang="html">
  <v-container id="contacts">
    <h1 class="display-2 font-weight-thin">{{ $t('contact.TITLE') }}</h1>
    <v-text-field
      v-model="email"
      :label="$t('contact.EMAIL')"
      color="grey"
      required
    ></v-text-field>
    <v-textarea
      color="grey"
      name="input-7-1"
      box
      :label="$t('contact.MESSAGE')"
      auto-grow
      v-model="message"
    ></v-textarea>
    <v-btn @click="sendMail()">
      {{ $t('contact.SUBMIT') }}
    </v-btn>
    <v-snackbar v-model="snackbar" color="Succes">
      {{ this.$t('contact.SNACKBAR') }}
      <v-btn dark flat @click="snackbar = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from 'axios'
export default {
  name: 'sendMail',
  data() {
    return {
      snackbar: false,
      email: '',
      message: '',
    }
  },
  methods: {
    sendMail() {
      if (this.email && this.message) {
        this.snackbar = true
        fetch(
          'https://q2h4r9iul2.execute-api.eu-west-3.amazonaws.com/dev/saveMail?mail=' +
            this.email +
            '&content=' +
            this.message
        ).then(res => {
          this.email = ''
          this.message = ''
          window.scrollTo(0, 0)
        })
      }
    },
  },
}
</script>

<style lang="css" scoped></style>
